import { render } from "./ContentComponent.vue?vue&type=template&id=e4410432"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Felhasznalo\\source\\repos\\favagas-tatabanya\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__